module.exports = __webpack_public_path__ + "img/Orkney_Islands.add5faad.png";